import { bootstrap } from './game/bootstrap';

bootstrap();
